export default "__VITE_ASSET__uC30$l0F__"